export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1300,
  xxl: 1600,
  xxxl: 1920,
};
